<form *ngIf="workerContractFormGroup" [formGroup]="workerContractFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="typeContractId">Tipo *</label>
            <p-dropdown [options]="typesContracts" formControlName="typeContractId" optionValue="id" [filter]="true" filterBy="name"
                optionLabel="name" placeholder="Seleccione tipo de contrato" appendTo="body" d-form-field-error />
        </div>
        <div class="col-6 input-field">
            <label for="hours" class="mr-1">Horas semanales</label>
            <p-inputNumber id="hours" (onInput)="calculateHourlyCost()" formControlName="hours" [minFractionDigits]="1" [maxFractionDigits]="2" [min]="0" [max]="70" [step]="0.5"></p-inputNumber>        
          </div>
        
        <div class="col-6 input-field">
            <label for="salary" class="mr-1">Salario bruto anual</label>
            <p-inputNumber id="salary" (onInput)="calculateHourlyCost()" formControlName="salary" [minFractionDigits]="1" [maxFractionDigits]="2" [min]="0"  [step]="0.5"></p-inputNumber>       
        </div>
        <div class="col-6 input-field">
            <label for="hourlyCost" class="mr-1">Coste hora</label>
            <p-inputNumber id="hourlyCost" formControlName="hourlyCost" [minFractionDigits]="1" [maxFractionDigits]="2" [min]="0"  [step]="0.5" [readonly]=true></p-inputNumber>       
        </div>
        <div class="col-6 input-field">
            <label for="colectiveAgreementId">Convenio *</label>
            <p-dropdown [options]="colectiveAgreements" formControlName="colectiveAgreementId" optionValue="id" [filter]="true" filterBy="name"
                optionLabel="name" placeholder="Seleccione el convenio" appendTo="body" d-form-field-error />
        </div>
        <div class="col-6 input-field">
            <label for="startDate">Fecha inicio</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="startDate" d-form-field-error appendTo="body"  id="startDate" [dateFormat]="'dd/mm/yy'" [showTime]="false" [showIcon]="true"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for="endDate">Fecha fin</label>
                <p-calendar formControlName="endDate" d-form-field-error appendTo="body"  id="endDate" [dateFormat]="'dd/mm/yy'" [showTime]="false" [showIcon]="true"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for="active" class="mr-1">Activo</label>
            <p-inputSwitch id="active" formControlName="active"></p-inputSwitch>
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerContract.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>